import { app } from '../../../../bootstrap/core';
import { confirmState, confirmStateName } from './confirm.state';
import { ConfirmService } from './confirm.service';
import { ConfirmComponent } from './confirm.component';
import '../../../../common/ui/partner/partnerList/partnerList';
import '../../../../common/ui/card/card';
import '../../../../common/ui/cardContainer/cardContainer';

app.config(confirmState);
app.component(ConfirmComponent.name, ConfirmComponent);
app.constant('confirmStateName', confirmStateName);
app.service('confirmService', ConfirmService);
app.value('isPasswordRequired', false);
